<template>
  <ServicePageLayout
    title="Fire Alarm History"
    subtitle="ประวัติระบบแจ้งเหตุเพลิงไหม้"
    icon="mdi-chart-line"
    icon-color="error"
    breadcrumb="Reports"
  >
    <FireAlarmHistoryFilter />
    <FireAlarmHistoryDataTable />
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import FireAlarmHistoryFilter from '@/components/fire_alarm_history/fire_alarm_history_filter.vue'
import FireAlarmHistoryDataTable from '@/components/fire_alarm_history/fire_alarm_history_datatable.vue'

export default {
  name: 'FireAlarmHistoryView',
  components: {
    ServicePageLayout,
    FireAlarmHistoryFilter,
    FireAlarmHistoryDataTable
  },
}
</script>
